"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "action", {
    enumerable: true,
    get: function() {
        return action;
    }
});
const _runAction = require("./runAction.js");
const _watchAction = require("./watchAction.js");
async function action(options, command) {
    if (options.watch) {
        return (0, _watchAction.watchAction)(options, command);
    } else {
        return (0, _runAction.runAction)(options, command);
    }
}
